import {TextField} from '@material-ui/core';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import {useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {UploadImage} from '../../../../shared/components/UploadImage';
import {IAllStates} from '../../../../store/rootReducer';
import {multipartFormData} from '../../../../utils';
import {AUTH_AGENCY_URL} from '../../../../utils/endpoints';
import {ErrorToast, SuccessToast} from '../../../../utils/toasters';
import {IRegisterStepperProps} from '../../brand/components/Step1';
import {StepperButtons} from '../../brand/components/StepperButtons';
import {IRegisterPersonalDetails} from '../../brand/dto/IRegister';
import {Form} from 'react-bootstrap';
import {InternalRoutes} from '../../../../enum/InternalRoutes';

export const Step3 = ({stepIdNumber, handleBackStep}: IRegisterStepperProps) => {
    const {t} = useTranslation();
    const history = useHistory();
    const [files, setFiles] = useState<Blob[] | MediaSource[]>();
    const [currentUser, setCurrentUser] = useState<IRegisterPersonalDetails>({
        contact: {
            phone: '',
        },
        firstName: '',
        id: 0,
        lastName: '',
    });
    const savedData = useSelector((state: IAllStates) => state.registration);

    const changeHandler = (event: React.ChangeEvent<HTMLInputElement>, isContact = false) => {
        const {name, value} = event.target;
        if (isContact) {
            setCurrentUser(prev => ({
                ...prev, contact: {
                    ...prev?.contact,
                    [name]: value,
                },
            }));
        } else {
            setCurrentUser(prev => ({...prev, [name]: value}));
        }
    };

    const changePhoneHandler = (value: string) => {
        setCurrentUser(prev => ({
            ...prev, contact: {
                ...prev?.contact,
                phone: value,
            },
        }));
    };

    const handleNextStep = () => {
        multipartFormData(files, `${AUTH_AGENCY_URL}/personal-details`, JSON.stringify({
            ...currentUser,
            id: savedData?.id,
        })).then(response => {
            if (response) {
                history.push(`${InternalRoutes.AGENCY_REGISTRATION}/${stepIdNumber + 1}?token=${response?.data?.verificationUUID}`);
                SuccessToast(t('auth.register.brand.step3.success'));
            }
        }).catch(error => ErrorToast(error));
    };

    useEffect(() => {
        if (!!savedData?.id) {
            setCurrentUser(savedData);
        }
        // eslint-disable-next-line
    }, [savedData?.id]);

    return (
        <Form className="w-100" onSubmit={(e) => {
            e.preventDefault();
            handleNextStep();
        }}>
            <div className="row justify-content-center">
                <div className="col-md-7">
                    <UploadImage saveFile={setFiles}
                                 isDeleteHidden={true}
                                 previewImage={currentUser?.profilePhoto?.path}
                                 acceptedFormats="image/jpeg, image/png, image/jpg"
                                 isPreviewArray={false}
                                 isMultiple={false}/>
                </div>

                <div className="col-md-6">
                    <TextField
                        label={t('auth.register.brand.step2.firstName')}
                        variant="outlined"
                        name="firstName"
                        onChange={changeHandler}
                        size="small"
                        required
                        value={currentUser?.firstName ?? ''}
                        className="w-100 my-2"
                    />
                </div>
                <div className="col-md-6">
                    <TextField
                        label={t('auth.register.brand.step2.lastName')}
                        variant="outlined"
                        name="lastName"
                        onChange={changeHandler}
                        size="small"
                        value={currentUser?.lastName ?? ''}
                        required
                        className="w-100 my-2"
                    />
                </div>
                <div className="col-md-6">
                    <PhoneInput
                        country="de"
                        value={currentUser?.contact?.phone ?? ''}
                        onChange={changePhoneHandler}
                        inputClass="w-100 my-2"
                    />
                </div>
                <div className="col-md-6"/>
                <div className="col-12 mt-4">
                    <StepperButtons currentStep={stepIdNumber - 1} handleNextStep={handleNextStep} isBackHidden={true}
                                    handleBackStep={handleBackStep}/>
                </div>

            </div>
        </Form>
    );
};
